var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserQuestionBase = function SvgUserQuestionBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12350_300717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4284 13.7143C15.2155 13.7143 18.2856 10.6442 18.2856 6.85714C18.2856 3.07005 15.2155 0 11.4284 0C7.64134 0 4.57129 3.07005 4.57129 6.85714C4.57129 10.6442 7.64134 13.7143 11.4284 13.7143Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8573 17.7144C22.8573 16.1365 24.1364 14.8573 25.7144 14.8573C27.2925 14.8573 28.5716 16.1365 28.5716 17.7144C28.5716 19.2924 27.2925 20.5716 25.7144 20.5716C24.7677 20.5716 24.0001 21.3391 24.0001 22.2859V23.7636C24.0001 24.7103 24.7677 25.4779 25.7144 25.4779C26.6612 25.4779 27.4287 24.7103 27.4287 23.7636C30.0671 23.0173 32.0001 20.5916 32.0001 17.7144C32.0001 14.2429 29.186 11.4287 25.7144 11.4287C22.2429 11.4287 19.4287 14.2429 19.4287 17.7144C19.4287 18.6612 20.1962 19.4287 21.143 19.4287C22.0898 19.4287 22.8573 18.6612 22.8573 17.7144Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7144 32.0001C26.9768 32.0001 28.0001 30.9768 28.0001 29.7144C28.0001 28.452 26.9768 27.4287 25.7144 27.4287C24.452 27.4287 23.4287 28.452 23.4287 29.7144C23.4287 30.9768 24.452 32.0001 25.7144 32.0001Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1429 28.5715V22.2858C18.6181 22.2858 16.5714 20.2391 16.5714 17.7144C16.5714 17.5506 16.5757 17.3879 16.5842 17.2262C15.0353 16.4419 13.2835 16 11.4286 16C5.11675 16 0 21.1168 0 27.4286C0 28.0597 0.511675 28.5715 1.14286 28.5715H21.1429Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12350_300717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  })))));
};
export default SvgUserQuestionBase;